const steps = [
  {
    number: "01",
    icon: "ri-search-line",
    title: "Request Availability",
    description: "Contact us by phone or form to check current availability for your vehicle type and storage duration.",
  },
  {
    number: "02",
    icon: "ri-file-list-3-line",
    title: "Select Your Plan",
    description: "Choose from short-term or long-term storage options. Rates vary by vehicle size and duration.",
  },
  {
    number: "03",
    icon: "ri-calendar-check-line",
    title: "Schedule Drop-Off",
    description: "Coordinate a convenient drop-off time. Motorcycle transport available if you need assistance.",
  },
  {
    number: "04",
    icon: "ri-shield-check-line",
    title: "Storage Begins",
    description: "Your vehicle is secured in our fully-alarmed indoor facility. Rest easy knowing it&apos;s protected.",
  },
];

export default function Process() {
  return (
    <section className="bg-[#161616] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-4">
            How It Works
          </p>
          <h2 className="font-serif text-white text-4xl lg:text-5xl font-bold mb-4">
            Simple &amp; Seamless Process
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto"></div>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connecting Line (desktop) */}
          <div className="hidden lg:block absolute top-10 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent z-0"></div>

          {steps.map((step) => (
            <div key={step.number} className="relative z-10 flex flex-col items-center text-center">
              {/* Number Circle */}
              <div className="w-20 h-20 flex items-center justify-center border-2 border-gold/40 rounded-full mb-6 bg-[#161616] relative">
                <span className="font-serif text-gold text-2xl font-bold">{step.number}</span>
                <div className="absolute -inset-1 rounded-full border border-gold/10"></div>
              </div>
              <div className="w-8 h-8 flex items-center justify-center mb-4">
                <i className={`${step.icon} text-xl text-gold`}></i>
              </div>
              <h3 className="font-serif text-white text-lg font-semibold mb-3">{step.title}</h3>
              <p
                className="font-sans text-[#9A9A9A] text-sm leading-relaxed"
                dangerouslySetInnerHTML={{ __html: step.description }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
